import React from "react"
import PropTypes from "prop-types"
import { Script, useStaticQuery, graphql } from "gatsby"
import Header from "../header/header"
import Footer from "../footer/footer"
import { ThemeProvider } from "styled-components"
import theme from "../../assets/styles/theme"
import { DivProvider } from "../../context/DivContext"
import "../../assets/styles/popup.css"

const Layout = ({ children, currentLocation, hideLinks, hideFooter }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <DivProvider>
      <ThemeProvider theme={theme}>
        <div className="pt-[88px]">
          <Header
            siteTitle={data.site.siteMetadata.title}
            currentLocation={currentLocation}
            hideLinks={hideLinks}
          />
          {children}
          {hideFooter ? "" : <Footer currentLocation={currentLocation} />}
          <Script
            async
            src="https://d335luupugsy2.cloudfront.net/js/loader-scripts/7127c767-212b-43a8-a54f-16eec366b30e-loader.js"
          ></Script>
        </div>
      </ThemeProvider>
    </DivProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
